<template>
  <div class="credit-widget i-radius-xl">
    <div class="widget-header i-text-subheading-2 i-text-neutral-120">
      <slot name="widget-header" />
    </div>
    <div class="widget-content d-flex flex-column">
      <slot name="widget-content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditWidget',
};
</script>

<style lang="scss" scoped>
.credit-widget {
  width: 32%;
  min-height: 368px;
  background: $light-neutral-default;
  border: 1px solid $light-neutral-60;

  @include respond-to('large') {
    width: 49%;
  }

  @include respond-to('small') {
    width: 100%;
  }

  .widget-header {
    height: 54px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid $light-neutral-60;
    gap: 8px;
  }

  .widget-content {
    padding: 24px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: $light-neutral-110;

    :first-letter {
      text-transform: uppercase;
    }

    .value {
      font-weight: 500;
      color: $light-neutral-120;
    }

    .line {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      &:not(:last-of-type) {
        padding-bottom: 16px;
      }

      @include respond-to('medium') {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }

      &.large {
        line-height: 24px;
        font-weight: 500;
        color: $light-neutral-120;

        &:not(:last-of-type) {
          padding-bottom: 24px;
        }

        .value {
          font-weight: 600;
          font-size: 20px;
        }
      }
    }

    .divider {
      width: 100%;
      height: 1px;
      background: $light-neutral-40;
      margin-bottom: 16px;
    }
  }
}
</style>
